export enum BuildView {
  Index = "INDEX",
  Steps = "STEPS",
  Summary = "SUMMARY",
  JobList = "JOB_LIST",
  Waterfall = "WATERFALL",
  Table = "TABLE",
  Canvas = "CANVAS",
  List = "LIST",
  Tests = "TESTS",
  Annotations = "ANNOTATIONS",
}
